import script from "./ProfileBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileBlock.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileBlock.vue?vue&type=style&index=0&id=da4f3470&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da4f3470"]])

export default __exports__